import React from 'react';
import type { IconProps } from '../Icons/types';

const ToastInfoIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      fill="var(--info-icon)"
    />
    <path
      d="M10.45 14.167V9.583a.417.417 0 0 0-.417-.417H9.167M9.392 5.352a.208.208 0 1 1 0 .417.208.208 0 0 1 0-.417M9.167 14.167h2.5"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
  </svg>
);

const ToastSuccessIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      fill="var(--success-icon)"
    />
    <path
      d="M6.5 10.25L8.75 12.5L13.75 7.5"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

const ToastWarningIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10.147 1.558a.833.833 0 0 0-1.461 0L.884 16.225c-.254.508-.038 1.137.482 1.392.15.075.315.117.484.117h16.3c.575 0 1.042-.467 1.042-1.042 0-.169-.042-.334-.117-.484a1.042 1.042 0 0 0-.35-.35L10.147 1.558Z"
      fill="var(--warning-icon)"
    />
    <path
      d="M10 7.083v4.167M10 13.75h.008"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
  </svg>
);

const ToastErrorIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="10"
      fill="var(--error-icon)"
    />
    <path
      d="M10 6.667v4.166M10 13.333h.008"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
  </svg>
);

export const ToastIcons = {
  Info: ToastInfoIcon,
  Success: ToastSuccessIcon,
  Warning: ToastWarningIcon,
  Error: ToastErrorIcon,
};
